import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'spk-password',
  templateUrl: './spk-password.component.html',
  styleUrls: ['./spk-password.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class SpkPasswordComponent {
  @Input() model: string;
  @Input() label: string;
  @Input() wrapped: boolean = true;
  @Input() disabled: boolean;
  @Input() maxlength: number;
  @Input() class: string;
  @Input() wrappedClass: string;
  @Input() placeholder: string;
  @Input() name: string;
  @Input() autoComplete: string = "off";
  @Output() modelChange: EventEmitter<string> = new EventEmitter<string>();
  constructor() { }

  modelChanged() {
    this.modelChange.emit(this.model);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/framework/spk/inputs/spk-password/spk-password.component.ts